import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { HomeService } from 'src/app/core/services/home.service';
import { Solution } from 'src/app/core/models/solutions-events';
import { AdditionalServiceAddon } from 'src/app/core/models/additional-service-addon';

@Component({
  selector: 'app-secured-home',
  templateUrl: './secured-home.component.html',
  styleUrls: ['./secured-home.component.scss'],
  standalone: false,
})
export class SecuredHomeComponent implements OnInit {
  solutions: Solution[] = [];
  additionalServices: AdditionalServiceAddon[] = [];

  isFetchingSolutionsEvents: boolean = true;
  isFetchingAdditionalServices: boolean = true;

  get companyName(): string {
    return this.userData.company.name;
  }

  constructor(
    private userData: UserDataService,
    private router: Router,
    private homeService: HomeService,
  ) {}

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData() {
    // Fetch solutions and events
    this.isFetchingSolutionsEvents = true;
    this.homeService.getSolutionAndEvents().subscribe({
      next: (solutionsAndEvents) => {
        this.solutions = solutionsAndEvents['solutions'] as Solution[];
        this.isFetchingSolutionsEvents = false;
      },
      error: (error) => {
        console.error('Error fetching solutions and events:', error);
        this.isFetchingSolutionsEvents = false;
      },
    });

    // Fetch additional services
    this.isFetchingAdditionalServices = true;
    this.homeService.getAdditionalServices().subscribe({
      next: (additionalServices) => {
        this.additionalServices = additionalServices as AdditionalServiceAddon[];
        this.isFetchingAdditionalServices = false;
      },
      error: (error) => {
        console.error('Error fetching additional services:', error);
        this.isFetchingAdditionalServices = false;
      },
    });
  }
}
